import {
  OrderResponse,
  PurchaseRequestItemState,
  PurchaseRequestItemV2,
  PurchaseRequestStatus,
  PurchaseRequestV2,
} from "../../../types";
import {
  PILL_LABELS,
  BIDDING_LABELS,
  pillResolver,
  deliveryResolver,
  DELIVERY_STATES,
} from "../../../utils";
import { DeliveryInterface } from "../../../types";
import i18next from "../../../i18n";

const labelToStyle = {
  [BIDDING_LABELS.IN_PROGRESS]: "bg-purple-100 text-purple-800",
  [BIDDING_LABELS.CONSULTATION]: "bg-orange-100 text-orange-800",
  [BIDDING_LABELS.OFFER_NOW]: "bg-yellow-100 text-yellow-800",
  [PILL_LABELS.OFFER_PENDING_OF_SELECTION]: "bg-yellow-100 text-yellow-800",
  [BIDDING_LABELS.SCHEDULED]: "bg-blue-100 text-blue-800",
  [BIDDING_LABELS.CLOSED]: "bg-red-100 text-red-800",
  [PILL_LABELS.OFFER_NOT_SELECTED]: "bg-red-100 text-red-800",
  [BIDDING_LABELS.INACTIVE]: "bg-red-100 text-red-800",
  [PILL_LABELS.BIDDING_CANCELED]: "bg-red-100 text-red-800",
  [PILL_LABELS.OFFER_SELECTED]: "bg-green-100 text-green-800",
  [BIDDING_LABELS.ACTIVE]: "bg-green-100 text-green-800",
  [BIDDING_LABELS.HAS_OFFER]: "bg-green-100 text-green-800",
  [PILL_LABELS.DRAFT]: "bg-gray-100 text-gray-800",
  [PILL_LABELS.REJECTED]: "bg-red-100 text-red-800",
  [PILL_LABELS.DELIVERED]: "bg-blue-100 text-blue-800",
  // Add styles for delivery states
  [DELIVERY_STATES.DRAFT]: "bg-gray-100 text-gray-800",
  [DELIVERY_STATES.SCHEDULED]: "bg-blue-100 text-blue-800",
  [DELIVERY_STATES.REJECTED]: "bg-red-100 text-red-800",
  [DELIVERY_STATES.ACCEPTED]: "bg-green-100 text-green-800",
  [DELIVERY_STATES.IN_PROGRESS]: "bg-purple-100 text-purple-800",
  [DELIVERY_STATES.CANCELLED]: "bg-red-100 text-red-800",
  [DELIVERY_STATES.DELIVERED]: "bg-green-100 text-green-800",
  [DELIVERY_STATES.COMPLETED]: "bg-green-100 text-green-800",
};

const purchaseRequestStatusStyle: Record<PurchaseRequestStatus, string> = {
  [PurchaseRequestStatus.DRAFT]: "bg-gray-100 text-gray-800",
  [PurchaseRequestStatus.IN_APPROVAL]: "bg-blue-100 text-blue-800",
  [PurchaseRequestStatus.QUOTING]: "bg-purple-100 text-purple-800",
  [PurchaseRequestStatus.PARTIALLY_AWARDED]: "bg-teal-100 text-teal-800",
  [PurchaseRequestStatus.AWARDED]: "bg-green-100 text-green-800",
  [PurchaseRequestStatus.PENDING_DELIVERY]: "bg-yellow-100 text-yellow-800",
  [PurchaseRequestStatus.DELIVERED]: "bg-green-100 text-green-800",
  [PurchaseRequestStatus.REJECTED]: "bg-red-100 text-red-800",
};

const purchaseRequestItemStateStyle: Record<PurchaseRequestItemState, string> =
  {
    [PurchaseRequestStatus.DRAFT]: "bg-gray-100 text-gray-800",
    [PurchaseRequestStatus.IN_APPROVAL]: "bg-blue-100 text-blue-800",
    [PurchaseRequestStatus.QUOTING]: "bg-purple-100 text-purple-800",
    [PurchaseRequestStatus.AWARDED]: "bg-green-100 text-green-800",
    [PurchaseRequestStatus.PENDING_DELIVERY]: "bg-yellow-100 text-yellow-800",
    [PurchaseRequestStatus.DELIVERED]: "bg-green-100 text-green-800",
    [PurchaseRequestStatus.REJECTED]: "bg-red-100 text-red-800",
  };

type PillProps = {
  order?: OrderResponse;
  delivery?: DeliveryInterface;
  purchaseRequest?: PurchaseRequestV2;
  purchaseRequestItem?: PurchaseRequestItemV2;
  selected?: boolean;
  isSeller?: boolean;
};

export const Pill = ({
  order,
  delivery,
  purchaseRequest,
  purchaseRequestItem,
  selected,
  isSeller,
}: PillProps) => {
  let label = "";
  let styles = "";

  if (purchaseRequest) {
    const status = purchaseRequest.overallStatus;
    label = i18next.t(`purchaseRequests.status.${status.toLowerCase()}`, {
      defaultValue: status,
    });
    styles = purchaseRequestStatusStyle[status] || "";
  } else if (purchaseRequestItem) {
    const state = purchaseRequestItem.state;
    label = i18next.t(`purchaseRequests.status.${state.toLowerCase()}`, {
      defaultValue: state,
    });
    styles = purchaseRequestItemStateStyle[state] || "";
  } else if (order) {
    label = pillResolver(order, { selected, isSeller });
    styles = labelToStyle[label] || "";
  } else if (delivery) {
    label = deliveryResolver(delivery);
    styles = labelToStyle[label] || "";
  }

  return (
    <span
      className={`px-2 inline-flex text-xxs leading-5 font-semibold rounded uppercase ${styles}`}
    >
      {label}
    </span>
  );
};

export default Pill;
